import React from 'react';
export function Footer() {
  return <footer className="bg-[#061F3D] px-3 py-4 text-center sm:px-6" data-id="element-64" data-mp="32wd2qgad7ltj">
      <p className="font-heading text-[0.66rem] font-bold uppercase tracking-wide text-white/90" data-id="element-65" data-mp="3gfiyquovsxjx">
        © 2026 CLEANING READY™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.64rem] leading-[1.35] text-white/55 sm:text-[0.72rem]" data-id="element-66" data-mp="36pft9v0kpr4p">
        CLEANING READY™ provides professional organization resources for
        cleaning businesses. It does not replace required professional training,
        manufacturer instructions, safety procedures, business judgment,
        insurance requirements, contracts or applicable regulations.
      </p>
      <p className="mt-1 text-[0.64rem] text-white/70 sm:text-[0.72rem]" data-id="element-67" data-mp="3qd6rjf2xfuzg">
        Terms &amp; Conditions • Privacy Policy • Contact
      </p>
      <p className="text-[0.64rem] text-white/70 sm:text-[0.72rem]" data-id="element-68" data-mp="29ydrvn3jig3k">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="underline" data-id="element-69" data-mp="2ez1l8ff8r90y">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}